import type { API, HighlightsModule } from 'chessboard/plugins/highlights/config/types';
import { Highlights } from 'chessboard/plugins/highlights/config/types';
import type { Core } from 'chessboard/core/config/types';
import type { UpdateParameters } from 'chessboard/plugins/highlights/api';
import { createHighlightsAPI } from 'chessboard/plugins/highlights/api';
import { init } from 'chessboard/plugins/highlights/event-handlers/init';
import { createHighlightsEventHandlers } from 'chessboard/plugins/highlights/event-handlers';
import type { Plugins } from 'chessboard/core/plugins/config/types';

/**
 * Create the highlights plugin. This consists of a module API that allows other plugins
 * to register highlights in response to events. Each module adds highlights, and the plugin
 * manages which highlight to show (i.e. which highlight takes precedence).
 */
export function createHighlightsPlugin(
  highlightsModules: HighlightsModule<UpdateParameters>[],
): Plugins.Model {
  return {
    api: createHighlightsAPI(highlightsModules),
    destroy,
    create: init,
    match: createHighlightsEventHandlers(),
    name: Highlights.Plugin.Name,
  };

  /**
   * Destroy any existing squares.
   */
  function destroy(context: Core.Context) {
    const { api, renderer } = context;

    const highlights = <API<UpdateParameters>>api.highlights;

    renderer?.removeHighlights(highlights.getAll(), context);
  }
}
